import { axios } from '~/clients';
import { CREATE_QUOTE_ANONYMOUS } from '~/constants/endpoints';
import Quote from '~/contracts/vdp/Quote';

type QuoteRequest = {
  deliveryZip5: string;
  routeId?: string;
  vehicleId: number;
};

type QuoteResponse = {
  quote: Quote;
};

export default async function fetchTransitChargeAnonymous(
  controller: AbortController,
  request: QuoteRequest,
  associatedVdpEventId: string
): Promise<Quote> {
  const { data } = await axios.post<QuoteResponse>(
    CREATE_QUOTE_ANONYMOUS,
    request,
    {
      headers: { 'correlation-id': associatedVdpEventId },
      signal: controller.signal
    }
  );

  return data.quote;
}
